export const TREE = 'assetData'
export const BRANCH = 'assets'

// Model Properties
export const PROP_ID = 'id'
export const PROP_LABEL = 'label'
export const PROP_GEOJSON = 'geoJSON'
export const PROP_COMMENTS = 'comments'
export const PROP_OPTIONS = 'options'

// Action Types
const prefix = '@@fc-spatial'
export const ADD_SPATIAL = '@@fc-spatial/ADD_SPATIAL'
export const UPDATE_SPATIAL = `${prefix}/UPDATE_SPATIAL`
export const REMOVE_SPATIAL = `${prefix}/REMOVE_SPATIAL`
export const CREATE_SPATIAL = `${prefix}/CREATE_SPATIAL`
export const EDIT_SPATIAL = `${prefix}/EDIT_SPATIAL`
export const CLEAR_SELECTED_SPATIAL = `${prefix}/CLEAR_SELECTED_SPATIAL`
export const SUBMIT_SPATIIAL = `${prefix}/SUBMIT_SPATIIAL`
export const TOGGLE_EDIT_SPATIAL = `${prefix}/TOGGLE_EDIT_SPATIAL`
export const SUBMIT_CHANGES_TO_SPATIAL = `${prefix}/SUBMIT_CHANGES_TO_SPATIAL`
export const TOGGLE_ACTIVE_TOOLS = `${prefix}/TOGGLE_ACTIVE_TOOLS`

// MIT props
export const ACTIVE_BUTTON = 'activeBtn'

// Other
export const ACTIVE_TOOLS_OP = 'isActiveToolsOp'
export const SPATIAL = 'spatial'
export const EDITING_SPATIAL = 'editingSpatial'
export const IS_EDITING = 'isEditing'
